import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListEmbedClassicRoute: InvariantJiraRoute = {
	name: 'software-list-classic-embed',
	path: '/jira/software/c/projects/:projectKey/list/embed',
};
